import React from 'react';
import PropTypes from 'prop-types';
import {Modal, ModalHeader, ModalBody} from 'reactstrap';
import {FormattedMessage} from "react-intl";
import AdvertForm from "../AdvertForm/AdvertForm";

class AdvertModal extends React.Component {
    static propTypes = {
        isOpen: PropTypes.bool,
        onToggle: PropTypes.func.isRequired,
        onAdvertFormSubmit: PropTypes.func.isRequired,
        advert: PropTypes.object,
        serviceTypeValues: PropTypes.array.isRequired,
        priceValuesVoice: PropTypes.array.isRequired,
        priceValuesSms: PropTypes.array.isRequired,
        canHaveHappyHours: PropTypes.bool,
    };

    onAdvertFormSubmit(model) {
        return this.props.onAdvertFormSubmit(model).then(() => {
            this.props.onToggle();
        });
    }

    render() {
        const {isOpen, onToggle, advert, serviceTypeValues, priceValuesVoice, priceValuesSms, canHaveHappyHours} = this.props;

        return (
            <Modal keyboard autoFocus isOpen={isOpen} toggle={onToggle} modalClassName="modal-large">
                <ModalHeader toggle={onToggle}>
                    <FormattedMessage id="advert_modal.title" defaultMessage="Advert"/>

                </ModalHeader>
                <ModalBody>
                    <AdvertForm advert={advert} onAdvertFormSubmit={::this.onAdvertFormSubmit}
                                serviceTypeValues={serviceTypeValues} priceValuesVoice={priceValuesVoice}
                                priceValuesSms={priceValuesSms} showPreview canHaveHappyHours={canHaveHappyHours}
                    />
                </ModalBody>
            </Modal>
        )
    }
}

export default AdvertModal;


// WEBPACK FOOTER //
// ./src/components/AdvertModal/AdvertModal.jsx